<template>
  <d-container fluid>
    <d-modal :centered="true">
      <d-modal-body class="p-0">
        <div class="bg-danger rounded-top p-2"></div>
        <div class="p-3">
          <div class="pt-2 px-2">
            <div class="text-muted"><i class="material-icons text-danger">warning</i> Error 403</div>
            <h3>The content you are trying to access is restricted.</h3>

            <div class="border border-danger p-2 my-3 text-center text-danger">
              Access denied for {{googleUser.mail}}
            </div>

            <p>If you think this is a mistake, please contact <a href="mailto:support@wwfint.org">support@wwfint.org</a> and include a screenshot of this page that shows the following,
            <ul class="mt-3">
              <li>Page URL</li>
              <li>Error message</li>
            </ul>
            </p>
            <p>Alternatively, you can try again with a valid credentials.</p>
          </div>
          <a class="btn btn-primary btn-block" href="javascript:window.location.reload(true)">Try again</a>
        </div>
      </d-modal-body>
    </d-modal>

    <d-row class="p-3">
      <d-col cols="12" class="p-0">
        <div class="mb-3 p-2 rounded bg-light">
          <div class="d-flex">
            <div class="ml-1 mr-2">
              <h4 class="m-0"><i class="material-icons text-secondary">search</i></h4>
            </div>
          </div>
        </div>
      </d-col>
      <d-col md="3">
        <d-row class="mb-4 mr-2" v-for="(item, index) in 2" :key="index">
          <d-col cols="12" class="mb-2 bg-secondary">&nbsp;</d-col>
          <d-col cols="12" v-for="(item, index) in 3" :key="index" class="mb-1 bg-light">&nbsp;</d-col>
        </d-row>
      </d-col>

      <d-col md="9" class="p-0">
        <div class="mb-3 p-3 border rounded" v-for="(item, index) in 4">
          <div class="d-flex">
            <div class="mr-2">
              <div data-mimetype="file" class="img border-0"></div>
            </div>
            <div class="container">
              <d-row>
                <d-col cols="12" class="mb-2 bg-secondary">&nbsp;</d-col>
                <d-col cols="12" v-for="(item, index) in 4" :key="index" class="mb-1 bg-light">&nbsp;</d-col>
              </d-row>
            </div>
          </div>
        </div>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>

  import { mapState } from 'vuex';
  export default {
    computed: {
      ...mapState(['googleUser']),
    },
  };
</script>